import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _ALIGN_ICONS;
export var FONT_SIZE = {
  EXTRA_SMALL: '0.64rem',
  SMALL: '1rem',
  NORMAL: '1.4rem',
  LARGE: '2rem'
};
export var CUSTOM_FONT_SIZE = 'CUSTOM_FONT_SIZE';

// Corresponds to $textAlignments in richTextEditor.module.scss
export var ALIGNMENTS = {
  LEFT: 'left',
  CENTER: 'center',
  RIGHT: 'right',
  JUSTIFY: 'justify'
};
export var ALIGN_ICONS = (_ALIGN_ICONS = {}, _defineProperty(_ALIGN_ICONS, ALIGNMENTS.LEFT, 'icon-left-aligned'), _defineProperty(_ALIGN_ICONS, ALIGNMENTS.RIGHT, 'icon-right-aligned'), _defineProperty(_ALIGN_ICONS, ALIGNMENTS.CENTER, 'icon-center-aligned'), _defineProperty(_ALIGN_ICONS, ALIGNMENTS.JUSTIFY, 'icon-format-align-justify'), _ALIGN_ICONS);
export var FONT_SIZES = [{
  name: 'Large',
  value: FONT_SIZE.LARGE
}, {
  name: 'Normal',
  value: FONT_SIZE.NORMAL
}, {
  name: 'Small',
  value: FONT_SIZE.SMALL
}, {
  name: 'Extra Small',
  value: FONT_SIZE.EXTRA_SMALL
}];
export var TEXT_ALIGN = [{
  name: 'Left',
  icon: ALIGN_ICONS.left,
  value: ALIGNMENTS.LEFT
}, {
  name: 'Center',
  icon: ALIGN_ICONS.center,
  value: ALIGNMENTS.CENTER
}, {
  name: 'Right',
  icon: ALIGN_ICONS.right,
  value: ALIGNMENTS.RIGHT
}, {
  name: 'Justify',
  icon: ALIGN_ICONS.justify,
  value: ALIGNMENTS.JUSTIFY
}];
export var TEXT_DECORATION = {
  'line-through': 'STRIKETHROUGH',
  underline: 'UNDERLINE'
};

// Corresponds to $lineHeights in richTextEditor.module.scss
export var LINE_HEIGHT_TYPES = {
  170: {
    label: __('170%'),
    value: 170
  },
  160: {
    label: __('160%'),
    value: 160
  },
  150: {
    label: __('Normal (150%)'),
    value: 150
  },
  130: {
    label: __('130%'),
    value: 130
  },
  110: {
    label: __('110%'),
    value: 110
  },
  90: {
    label: __('90%'),
    value: 90
  },
  80: {
    label: __('80%'),
    value: 80
  },
  70: {
    label: __('70%'),
    value: 70
  },
  60: {
    label: __('60%'),
    value: 60
  },
  50: {
    label: __('50%'),
    value: 50
  },
  40: {
    label: __('40%'),
    value: 40
  }
};
export var BLOCK_STYLE_PREFIX = 'blockStyle_';
export var BLOCK_STYLE_TYPES = {
  TEXT_ALIGNMENT: 'textAlignment',
  LINE_HEIGHT: 'lineHeight'
};